<template>
  <a-form-model ref="form" :model="model" slot="detail">
    <a-col :span="12">
      <a-form-model-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-model="model.business_form_no" :disabled="isDisabled"></a-input>
      </a-form-model-item>
    </a-col>
    <a-col :span="12" >
      <a-form-model-item label="隐患程度" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <j-dict-select-tag type="list" v-model="epDanger.dangerLevel" dictCode="ep_danger_level" :disabled="isDisabled"/>
      </a-form-model-item>
    </a-col>
    <a-col :span="12" >
      <a-form-model-item label="隐患地点" :labelCol="labelCol" :wrapperCol="wrapperCol" >
        <a-input v-model="epDanger.dangerAddress" :disabled="isDisabled"></a-input>
      </a-form-model-item>
    </a-col>
    <a-col :span="12" >
      <a-form-model-item label="整改期限" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <j-date :format="dateFormat" v-model="epDanger.correctiveTerm" style="width: 100%" :disabled="isDisabled"/>
      </a-form-model-item>
    </a-col>
    <span v-if="model.model_code == 'HiddenDangerForm'">
      <a-col :span="12" >
        <a-form-model-item label="设为罚扣" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <j-switch v-model="epDanger.isPenalty" :disabled="isDisabled"></j-switch>
        </a-form-model-item>
      </a-col>
      <a-col :span="12" v-if="epDanger.isPenalty == 'Y'">
        <a-form-model-item label="罚扣金额" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-input v-model="epDanger.penaltyMoney" :disabled="isDisabled"></a-input>
        </a-form-model-item>
      </a-col>
      <a-col :span="12" >
        <a-form-model-item label="事业群" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-select-depart v-model="epDanger.businessGroupId" :multi="false" :backDepart="true" :disabled="isDisabled"></j-select-depart>
        </a-form-model-item>
      </a-col>
      <a-col :span="12" >
        <a-form-model-item label="事业处" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-select-depart v-model="epDanger.businessUnitId" :multi="false" :backDepart="true" :disabled="isDisabled"></j-select-depart>
        </a-form-model-item>
      </a-col>
    </span>
    <span v-if="model.model_code == 'DelayForm'">
        <a-col :span="12" >
          <a-form-model-item label="延期后整改期限" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <j-date v-model="epDanger.deferCorrectiveTerm"  style="width: 100%" :disabled="isDisabled"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12" >
          <a-form-model-item label="延期申請緣由" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-model="epDanger.deferRequestReason" :disabled="isDisabled" :title="epDanger.deferRequestReason"></a-input>
      </a-form-model-item>
        </a-col>
      </span>
    <a-col :span="24">
      <a-form-model-item label="隐患描述" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
        <a-textarea v-model="epDanger.dangerDescription" rows="2" :disabled="isDisabled" :title="epDanger.dangerDescription"/>
      </a-form-model-item>
    </a-col>
  </a-form-model>
</template>

<script>
  import {httpAction, getAction, postAction} from '@/api/manage'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'EnvForm',
    components: {
      JInput
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        tabName:"申请单",
        epDanger: {},
        dateFormat:"YYYY-MM-DD",
        showAllApprover:true,
        isDisabled:true,
        processChartPrefix: "",
        processChartSuffix: "&Language=zh-TW",
        processGuid: "be00c9ad-45e8-a5c4-9c83-1523494a8a70",
        loading:true,
        model: {
        },
        labelCol: {
          xs: {span: 24},
          sm: {span: 6},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },

        url: {
          loadEpDangerInfo: "/epm/publicApi/loadEpDangerInfoByFormNo",
        }
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      formDisabled() {
        return this.disabled
      },
    },

    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      console.log("current processGuid --> " + this.model.processGuid);
    },

    methods: {

      add() {
        this.edit(this.modelDefault);
      },

      edit(record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.model_code == 'HiddenDangerForm'){
          this.tabName = "申请单（隐患单）";
        } else if (record.model_code == 'DelayForm'){
          this.tabName = "申请单（隐患延期单）";
        }
        this.loadEpDangerInfo(this.model.business_form_no, this.model.model_code);
      },

      //根据业务单号查询
      loadEpDangerInfo(business_form_no, model_code){
        let param = {
          formNo: business_form_no,
          modelCode: model_code
        }
        getAction(this.url.loadEpDangerInfo,param).then(res=>{
          if (res.success) {
            this.epDanger = res.result;
          }
        })
      },

    }
  }
</script>